<script lang="ts">
	//Stores
	import { devices } from 'src/stores/lists/devices';
	import { sidePanelState } from 'src/stores/ui/sidepanel-public';
	//Helpers
	import { checkIsComponent } from 'src/components/Sidepanel/sidepanel-helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import DEVICE_SIDE_PANEL_LAYOUT_CONFIG from './device-layout-imports';

	$: deviceType =
		$sidePanelState.type === 'device'
			? $devices?.[$sidePanelState.id]?.type || $devices?.[real_id($sidePanelState.id)]?.type
			: null;
</script>

{#key deviceType}
	<svelte:component this={checkIsComponent(DEVICE_SIDE_PANEL_LAYOUT_CONFIG?.[deviceType])} />
{/key}
